// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","350":"component---src-pages-impressum-js","496":"component---src-pages-datenschutz-js","834":"94726e6d"}[chunkId] + "-" + {"293":"9c2b828bb278d559318b","350":"67726d08880c227f9bf9","496":"cc1aef63c399888015d1","834":"3ecd116f36e8ef32b471"}[chunkId] + ".js";
};